import styled from 'styled-components'

export const OverlayFillUi = styled.div`
  pointer-events: none;
  height: inherit;
`
